
import { MapPin } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface RegionSelectorProps {
  selectedRegion: string;
  setSelectedRegion: (value: string) => void;
}

interface Region {
  code: string;
  name: string;
  active: boolean;
  currency: string;
}

export const RegionSelector = ({
  selectedRegion,
  setSelectedRegion,
}: RegionSelectorProps) => {
  const { data: regions } = useQuery({
    queryKey: ["regions"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("regions")
        .select("code, name, active, currency")
        .eq("active", true)
        .order("name");
      
      if (error) throw error;
      return data as Region[];
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  // Find current region's data
  const currentRegion = regions?.find(r => r.code === selectedRegion);

  return (
    <div className="relative inline-flex items-center gap-1 bg-white border border-gray-200 rounded-xl px-4 py-2 text-sm w-full">
      <MapPin className="h-4 w-4 text-primary" />
      <Select
        value={selectedRegion}
        onValueChange={setSelectedRegion}
      >
        <SelectTrigger className="border-0 p-0 h-auto font-medium text-sm focus:ring-0 focus:ring-offset-0 w-auto bg-transparent">
          <SelectValue>
            {currentRegion ? (
              currentRegion.name
            ) : (
              selectedRegion && selectedRegion.charAt(0).toUpperCase() + selectedRegion.slice(1)
            )}
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          {regions?.map(region => (
            <SelectItem key={region.code} value={region.code} className="capitalize">
              {region.name}
            </SelectItem>
          ))}
          {!regions?.length && (
            <SelectItem value="nairobi">Nairobi</SelectItem>
          )}
        </SelectContent>
      </Select>
    </div>
  );
};
